import { useCallback, useMemo, useState } from 'react';
import { CommonProperties } from '../../common/common.interfaces';
import CustomError, { CustomErrorProps } from '../../common/components/CustomError';
import UniversalConstructorItemPane from './UCItemPane';
import { MapperConfigurationSet, UniversalConstructorContainer } from '../universalConstructor.interfaces';
import { Accordion, Card } from 'react-bootstrap';

interface UniversalConstructorImportTableProps extends CommonProperties {
  container: UniversalConstructorContainer
  mapperConfigurationSet: MapperConfigurationSet
}

export default function UniversalConstructorImportTable (props : UniversalConstructorImportTableProps){
  
  const [ImportError, setImportError]: [CustomErrorProps, any] = useState(undefined)
  
  const handleCloseImportError = useCallback((e) => {
    setImportError({
      visible: false
    })
  }, [])


  // #region VIEW
  const view = useMemo(() => {

    if(!props.mapperConfigurationSet || !props.mapperConfigurationSet.relations || !props.container) {
      return
    }
    const orders = []
    const failures = []
    for(const order of props.container.ordersSuccessful) {
      orders.push(
        <Card className="p-0 m-0">
          <UniversalConstructorItemPane 
            orderWrapper={order}
          />
        </Card>
      )
    }
    if(props.container.ordersFailed) {
      for(const failed of props.container.ordersFailed) {
        failures.push(
          <Card className="p-0 m-0">
            <UniversalConstructorItemPane 
              orderWrapper={failed}
            />
          </Card>
        )
      }
    }
    
    
    return (
      <div>
        <div hidden={failures.length === 0}>
          <Accordion defaultActiveKey="0" className='custom-accordion review-card warning'>
            <Accordion.Item eventKey='0'>
            <div style={{wordBreak: 'break-all', whiteSpace: 'pre-wrap'}} className="review-card">
                <Accordion.Header>FAILURES [{failures.length}]</Accordion.Header>
                <Accordion.Body>{failures}</Accordion.Body>
            </div>
            </Accordion.Item>
          </Accordion>
        </div>
        <div hidden={orders.length === 0}>
          <Accordion defaultActiveKey="0" className='custom-accordion review-card success'>
            <Accordion.Item eventKey='0'>
            <div style={{wordBreak: 'break-all', whiteSpace: 'pre-wrap'}} className="review-card">
                <Accordion.Header>ORDERS [{orders.length}]</Accordion.Header>
                <Accordion.Body>{orders}</Accordion.Body>
            </div>
            </Accordion.Item>
          </Accordion>
        </div>
        
        <CustomError closeError={handleCloseImportError} content={ImportError?.content} description={ImportError?.description} title={ImportError?.title} visible={ImportError?.visible} />
      </div>
    )
  }, [props.mapperConfigurationSet, props.container])

  return view
}